import { FC } from 'react';

import { IconProps } from '../../types/icon.types';

/**
 * Иконка «инфо» для заголовка МАК-карт в групповой терапии:
 * серый круг с символом i.
 */
export const MacInfoIcon: FC<IconProps> = ({
  width = 16,
  height = 16,
  className,
}) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <rect width="16" height="16" rx="8" fill="#BFBFBF" />
    <path
      d="M5.33398 5.33203C5.33398 4.8016 5.57982 4.29289 6.0174 3.91782C6.45499 3.54275 7.04848 3.33203 7.66732 3.33203H8.33398C8.95282 3.33203 9.54632 3.54275 9.9839 3.91782C10.4215 4.29289 10.6673 4.8016 10.6673 5.33203C10.6919 5.76487 10.5751 6.19396 10.3346 6.55468C10.0941 6.9154 9.74297 7.18822 9.33398 7.33203C8.925 7.52378 8.57382 7.88754 8.33334 8.3685C8.09286 8.84946 7.9761 9.42158 8.00065 9.9987M8.00065 12.6654V12.672"
      stroke="#2C3038"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
